import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 1 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_AffectedComponent = _resolveComponent("AffectedComponent");
    const _component_Duration = _resolveComponent("Duration");
    const _component_StartDate = _resolveComponent("StartDate");
    const _component_EndDate = _resolveComponent("EndDate");
    const _component_Reason = _resolveComponent("Reason");
    const _component_RequiredFields = _resolveComponent("RequiredFields");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_AffectedComponent, {
            class: "mb-4",
            "component-id": _ctx.modelValue.mutedComponent.componentId,
            "component-type": _ctx.modelValue.mutedComponent.componentType,
            "should-cascade": _ctx.modelValue.shouldCascade,
            "system-id": _ctx.modelValue.systemId
        }, null, 8, ["component-id", "component-type", "should-cascade", "system-id"]),
        (_ctx.canEditFullDuration)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_Duration, {
                    "model-value": [_ctx.modelValue.start, _ctx.modelValue.end],
                    "fixed-start": false,
                    class: "mb-4",
                    "onUpdate:modelValue": _ctx.updateDuration
                }, null, 8, ["model-value", "onUpdate:modelValue"])
            ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_StartDate, {
                    class: "mb-4",
                    "start-date": _ctx.modelValue.start
                }, null, 8, ["start-date"]),
                _createVNode(_component_EndDate, {
                    class: "mb-4",
                    "model-value": _ctx.modelValue.end,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => _ctx.$emit('update:model-value', { ..._ctx.modelValue, end: value }))
                }, null, 8, ["model-value"])
            ])),
        _createVNode(_component_Reason, {
            "model-value": _ctx.modelValue.reason,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => _ctx.$emit('update:model-value', { ..._ctx.modelValue, reason: value }))
        }, null, 8, ["model-value"]),
        _createVNode(_component_RequiredFields, { class: "mt-4" })
    ], 64));
}
